import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {

        if (pathname !== '/otp-verification') {
            localStorage.removeItem('otpTimer');
        }

        
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant"   
        });

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

    }, [pathname]);

    return null;   
};

export default ScrollToTop;
